import slug from "slug";

export default {
  document: $(document),
  body: $("html, body"),
  docsContent: $(".docs-product-content"),
  sidebarList: null,
  docsTitles: null,
  init() {
    if (this.docsContent === undefined) return;
    this.sidebarList = this.docsContent.find(".product-content-list ul");
    this.docsTitles = this.docsContent.find("h2");
    console.log(this.docsTitles);
    if (this.docsTitles.length) {
      this.docsTitles.each((i, e) => {
        const title = $(e);
        const text = title.text();
        const slugTitle = slug(text);
        title.attr("id", slugTitle);
        this.sidebarList.append(
          `<li>
            <a href="#${slugTitle}">${text}</a>
          </li>`
        );
      });
    } else {
      $('.product-content-list').hide();
    }
    this.document.on("click", ".product-content-list a", null, (e) => {
      e.preventDefault();
      const currentItem = $(e.target).attr("href");
      const itemOffset = $(currentItem).offset().top;
      const scrollTop = $("body").hasClass("admin-bar")
        ? itemOffset - 32 * 2
        : itemOffset - 32;
      this.body.stop().animate({ scrollTop }, 256, "linear");
    });
  },
};
